import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { EntityService } from "../../services";
import EntityDetail from "./entity_detail";

const EntityDetailFromDevice = ({ deviceSerialNumber, isMobile }) => {  
    const [displayEntity, setDisplayEntity] = useState(null);

    useEffect(() => {
        setDisplayEntity(null);

        if (deviceSerialNumber) {
            EntityService.getBySerialNumber(deviceSerialNumber)
                .then(({ entity }) => setDisplayEntity(entity))
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [deviceSerialNumber]);

    return displayEntity != null ? <EntityDetail isMobile={isMobile} entity={displayEntity} /> : <div className="loader">{i18next.t("loading")}</div>;
};

export default EntityDetailFromDevice;